console.log("revealing button");
if (!customElements.get('revealing-button')) {
  customElements.define(
    'revealing-button',
    class RevealingButton extends HTMLButtonElement {
      constructor () {
        super()

        if (!this.revealElement) {
          throw new Error(`${this.localName} requires an element to reveal`)
        }
      }

      connectedCallback () {
        window.setTimeout(() => {
          const width = this.getRevealElementWidth()

          this.revealElement.style.setProperty('--Width', `${width}px`)
        }, 2000)
      }

      getRevealElementWidth () {
        this.revealElement.style.width = 'auto'
        this.revealElement.style.transition = 'none'

        const width = this.revealElement.offsetWidth

        this.revealElement.style.width = ''
        this.revealElement.style.transition = ''

        return width + this.marginBetweenTextAndIcon
      }

      get revealElement () {
        return this.querySelector(`[data-revealing-button-el="reveal"]`)
      }

      get marginBetweenTextAndIcon () {
        return 10
      }
    },
    { extends: 'button' }
  )
}
